<template>
	<div class="userInfomation">
		<div class="user">
			<div @click="visible=true">
				<img src="../../../assets/icons/icon-user.svg" alt="" class="userImg">
				<p class="user-name" >
          {{user.name}}
				</p>
			</div>
			<b-btn 
              class="btn btn-text p-0 text-nowrap text-13 text-md-16 mr-0 ml-md-3 tutorial termsBtn" 
              href="/m3dhub/tutorial/Hub_Manual.pdf"
              target="_blank" download
            >메뉴얼</b-btn>
		</div>
		<div v-show="visible" class="userDetail">
			<h2>내 계정</h2>
			<div class="user">
					<img src="../../../assets/icons/icon-user.svg" class="userImg" />
					<p class="user-name">
            {{user.name}}
					</p>
			</div>
			<a href="#" class="logout" @click="logout">로그아웃</a>
			<button class="close" @click="visible=false">닫기</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		userName: {
			type: String,
			default () {
				return "userName"
			}
		},
		image: {
			type: String,
			default () {
				return "/img/icons/icon-user.svg"
			}
		},
		type : {
			type : String,
			default (){
				return ""
			}
		}
	},
	data() {
		return {
			visible: false
		}
	},
	methods: {
		logout() {
			this.$store.commit('setState', ['user', null])
			localStorage.removeItem(
				process.env.VUE_APP_PROTOCOL
				? "m3dHubEditor__token"
				: "kirinote__token"
			)
			this.$router.replace( '/' ) ; 
		},
	}
}
</script>
<style lang="scss" scoped>
.userInfomation {
  grid-area: user;
  // min-width: 160px;
  // flex-shrink: 0; 
	
	padding-left: 24px;
	padding-right: 40px; 

	.templateSearch & {
		padding-left: 0px;
		padding-right: 0px; 
	}

	.user {
		// padding: 0 24px; 
		display: flex; justify-content: flex-start; align-items: center; 
		cursor: pointer;
		>div{
			display: flex; justify-content: flex-start; align-items: center; 
			cursor: pointer;
		}
		.user-name {
			position: relative;
			max-width: 160px; max-height: 54px;
			margin-bottom: 0; 
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			color: $gray-6;  
		}
		img {
			width: auto; max-height: 24px;
			margin: 0 8px 0 0;
		}
	}
	.userDetail {
		display: grid;
		grid-template:
		'title close' auto
		'user user' 1fr
		'logout logout' auto /
		auto auto ;
		justify-content: space-between; align-items: center;
		position: absolute; top: 10px; right: 10px;
		width: 290px; height: 177px;
		border: 1px solid #999;
		padding: 24px;
		background-color: #fff;
		box-shadow: 0px 4px var( --default-gap ) rgba(91,91,91,.3);
	
		h2 {grid-area: title;
		}
		.close {grid-area: close;
			width: 24px; height: 24px;
			background: url('@/assets/icons/icon-close.svg') center no-repeat;
			font-size: 0;
		}
		.user {
			grid-area: user;
			padding: 8px;
			border: 1px solid #999; 
		}
		.logout {
			display: inline-block;
			grid-area: logout;
			justify-self: center;
			color: #999;
			text-decoration: underline;
		}
	}
}

</style>
